import { createFileRoute } from '@tanstack/react-router';
import type { ReactElement } from 'react';
import { z } from 'zod';

import { LinksPage } from '~/features/links/links-page';
import { ProvenanceSheet } from '~/features/links/provenance-sheet';
import { useProvenanceEntry } from '~/features/links/use-provenance-entry';

/**
 * A record's links (boards 09-links and 09-links-empty). `?entry=` opens the
 * provenance of one row a link wrote into this record, over the list: the
 * address the entries' own mark can hand out. `?link=` opens one link's
 * detail sheet (U3 of docs/plans/ui-quick-fixes.md), from either end.
 */
const search = z.object({ entry: z.string().optional(), link: z.string().optional() });

function LinksRoute(): ReactElement {
  const { recordId } = Route.useParams();
  const { entry, link } = Route.useSearch();
  const navigate = Route.useNavigate();
  const held = useProvenanceEntry(recordId, entry ?? null);
  return (
    <>
      <LinksPage
        key={recordId}
        recordId={recordId}
        linkId={link ?? null}
        onLinkId={(next) => void navigate({ search: (prev) => ({ ...(prev.entry === undefined ? {} : { entry: prev.entry }), ...(next === null ? {} : { link: next }) }) })}
      />
      <ProvenanceSheet entry={held} recordId={recordId} onDismiss={() => void navigate({ search: (prev) => (prev.link === undefined ? {} : { link: prev.link }) })} />
    </>
  );
}

export const Route = createFileRoute('/_app/records/$recordId/links/')({
  validateSearch: search,
  component: LinksRoute,
});
